import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { CircularProgress } from "@circle-react-uikit/TipTap/AttachmentPreviews/CircularProgress";
import { Typography } from "@circle-react-uikit/Typography";

export const UploadingFile = ({ progress = 0, isIndeterminate }) => (
  <div className="flex content-between justify-between py-3">
    <div className="flex gap-1">
      <span className="flex w-6 items-center">
        <Icon type="20-course-file" size={20} className="text-default" />
      </span>
      <Typography.LabelSm weight="medium" color="text-default">
        {t("courses.edit.lesson.upload_progress", {
          progress: progress.toFixed(0),
        })}
      </Typography.LabelSm>
    </div>
    <div className="w-5">
      <span className="flex items-center">
        {isIndeterminate ? (
          <Icon type="loader" />
        ) : (
          <CircularProgress percentage={progress} size={20} strokeWidth={1.5} />
        )}
      </span>
    </div>
  </div>
);

UploadingFile.propTypes = {
  progress: PropTypes.number,
  isIndeterminate: PropTypes.bool,
};
